var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.payload.freezed_until)?_c('div',{staticClass:"is-flex is-align-items-center"},[_c('img',{staticClass:"btn",attrs:{"src":"/ice_cube.png","width":"30px"},on:{"click":function($event){return _vm.toggle()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }